import "./BlogPreview.css";
import { useNavigate } from "react-router-dom";
import TagList from "../TagList/TagList";
import { formatDate } from "../../util/formatDate";

export function BlogPreview({ post, onClick }) {
    const navigate = useNavigate();

    const handleClick = () => {
        if (onClick) {
            onClick();
        }
        navigate(`/posts/${post.slug.current}`);
    };
    return (
        <div className="blogPreview" key={post.title}>
            <button className="blogPreviewTitle" onClick={handleClick}>
                {post.title}
            </button>
            <h3 className="blogPreviewDate">{formatDate(post.date)}</h3>
            <TagList tags={post.tags} />
        </div>
    );
}
